import { render, staticRenderFns } from "./CompatabilityLove.vue?vue&type=template&id=3bbd73e7&scoped=true&"
import script from "./CompatabilityLove.vue?vue&type=script&lang=js&"
export * from "./CompatabilityLove.vue?vue&type=script&lang=js&"
import style0 from "./CompatabilityLove.vue?vue&type=style&index=0&id=3bbd73e7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbd73e7",
  null
  
)

export default component.exports